import React, { useEffect } from 'react';
import PortfolioFilterButton from './PortfolioFilterButton';
import {ReactComponent as stockIcon} from '../../assets/stock.svg'
import {ReactComponent as clockIcon} from '../../assets/clock.svg'
import {ReactComponent as draftIcon} from '../../assets/draft.svg'
import {ReactComponent as closedIcon} from '../../assets/closed.svg'
import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { PortfolioStatus } from '../../models/Portfolio';
import { loadPortfolioCount, setViewType } from '../../store/actions/portfolioLibrary';
import { useTranslation } from 'react-i18next';

const PortfolioFilter: React.FC = () => {
    const viewType = useAppSelector(state => state.portfolioLibrary.viewType);
    const portfoliosCount = useAppSelector(state => state.portfolioLibrary.portfoliosCount);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (portfoliosCount === undefined){
            dispatch(loadPortfolioCount());
        }
    }, [dispatch, portfoliosCount])

    return <Box display={"flex"} width={"100%"} gap={"16px"}>
            <PortfolioFilterButton isActive={viewType === PortfolioStatus.Live} count={portfoliosCount !== undefined ? portfoliosCount.filter(i => i.status === PortfolioStatus.Live)[0].count : undefined} title={t('PortfolioPageViewTypeLive')} icon={stockIcon} onClick={() => dispatch(setViewType(PortfolioStatus.Live))} />
            <PortfolioFilterButton isActive={viewType === PortfolioStatus.Pending} count={portfoliosCount !== undefined ? portfoliosCount.filter(i => i.status === PortfolioStatus.Pending)[0].count : undefined} title={t('PortfolioPageViewTypePending')} icon={clockIcon} onClick={() => dispatch(setViewType(PortfolioStatus.Pending))} />
            <PortfolioFilterButton isActive={viewType === PortfolioStatus.Draft} count={portfoliosCount !== undefined ? portfoliosCount.filter(i => i.status === PortfolioStatus.Draft)[0].count : undefined} title={t('PortfolioPageViewTypeDraft')} icon={draftIcon} onClick={() => dispatch(setViewType(PortfolioStatus.Draft))} />
            <PortfolioFilterButton isActive={viewType === PortfolioStatus.Closed} count={portfoliosCount !== undefined ? portfoliosCount.filter(i => i.status === PortfolioStatus.Closed)[0].count : undefined} title={t('PortfolioPageViewTypeClosed')} icon={closedIcon} onClick={() => dispatch(setViewType(PortfolioStatus.Closed))} />
        </Box>
}

export default PortfolioFilter;